

//export const host = 'http://11813a47.ngrok.io/';
//export const host = 'http://acd7a8c2.ngrok.io/';
//export const host = 'http://api-beta.magnumleap.com/';
//export const host = 'http://127.0.0.1:8000/';
export const host = 'http://api-agency.magnumleap.com/'; 

export const setup          = host + 'api/v1/setup/';
export const sys            = host + 'api/v1/sys/';
export const data_source    = host + 'api/v1/setup/data_source/';
export const login          = host + 'api-auth/login';
export const avatar         = host + 'img/user/';



// WEBPACK FOOTER //
// ./src/Setup/config/api.js